/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.TrendSettings = factory(root.ForStractionServiceApi.ApiClient);
  }
}(this, function(ApiClient) {
  'use strict';




  /**
   * The TrendSettings model module.
   * @module model/TrendSettings
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>TrendSettings</code>.
   * @alias module:model/TrendSettings
   * @class
   */
  var exports = function() {
    var _this = this;










  };

  /**
   * Constructs a <code>TrendSettings</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/TrendSettings} obj Optional instance to populate.
   * @return {module:model/TrendSettings} The populated <code>TrendSettings</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('CategoryNameFI')) {
        obj['CategoryNameFI'] = ApiClient.convertToType(data['CategoryNameFI'], 'String');
      }
      if (data.hasOwnProperty('CategoryNameEN')) {
        obj['CategoryNameEN'] = ApiClient.convertToType(data['CategoryNameEN'], 'String');
      }
      if (data.hasOwnProperty('CategoryNameSE')) {
        obj['CategoryNameSE'] = ApiClient.convertToType(data['CategoryNameSE'], 'String');
      }
      if (data.hasOwnProperty('CategoryName')) {
        obj['CategoryName'] = ApiClient.convertToType(data['CategoryName'], 'String');
      }
      if (data.hasOwnProperty('ScopeNameFI')) {
        obj['ScopeNameFI'] = ApiClient.convertToType(data['ScopeNameFI'], 'String');
      }
      if (data.hasOwnProperty('ScopeNameEN')) {
        obj['ScopeNameEN'] = ApiClient.convertToType(data['ScopeNameEN'], 'String');
      }
      if (data.hasOwnProperty('ScopeNameSE')) {
        obj['ScopeNameSE'] = ApiClient.convertToType(data['ScopeNameSE'], 'String');
      }
      if (data.hasOwnProperty('ScopeName')) {
        obj['ScopeName'] = ApiClient.convertToType(data['ScopeName'], 'String');
      }
      if (data.hasOwnProperty('ID')) {
        obj['ID'] = ApiClient.convertToType(data['ID'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * @member {String} CategoryNameFI
   * @default ''
   */
  exports.prototype['CategoryNameFI'] = '';
  /**
   * @member {String} CategoryNameEN
   * @default ''
   */
  exports.prototype['CategoryNameEN'] = '';
  /**
   * @member {String} CategoryNameSE
   * @default ''
   */
  exports.prototype['CategoryNameSE'] = '';
  /**
   * @member {String} CategoryName
   * @default ''
   */
  exports.prototype['CategoryName'] = '';
  /**
   * @member {String} ScopeNameFI
   * @default ''
   */
  exports.prototype['ScopeNameFI'] = '';
  /**
   * @member {String} ScopeNameEN
   * @default ''
   */
  exports.prototype['ScopeNameEN'] = '';
  /**
   * @member {String} ScopeNameSE
   * @default ''
   */
  exports.prototype['ScopeNameSE'] = '';
  /**
   * @member {String} ScopeName
   * @default ''
   */
  exports.prototype['ScopeName'] = '';
  /**
   * @member {Integer} ID
   * @default 0
   */
  exports.prototype['ID'] = 0;



  return exports;
}));


